import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import { variables } from '../../assets/styles/variables';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';

const ReservedTargetOrdersCardContainer = styled.div`
  border-radius: ${variables.borderRadius.borderRadiusMdPlus};
  background-color: ${themeColors.colorBackgroundPrimary};
  box-shadow: 0px 3px 9px 0px ${themeColors.colorShadowCard};
  border: 1px solid ${themeColors.colorWhite};
  padding: ${pxToRem(16)};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    padding: ${pxToRemMd(16)} ${pxToRemMd(16)} ${pxToRemMd(12)};
  }
`;

const ReservedTargetOrdersHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${pxToRem(12.5)};
  border-bottom: 1px solid ${themeColors.colorBorderPrimary};
  margin-bottom: ${pxToRem(11.5)};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    padding-bottom: ${pxToRemMd(12)};
    margin-bottom: ${pxToRemMd(11)};
    flex-wrap: wrap;
  }
`;

const ReservedTargetOrdersTitle = styled.p`
  font-family: ${variables.family.goldSilver};
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0;
  color: ${themeColors.colorTextSecondary};
  margin-right: auto;
  padding-right: ${pxToRem(10)};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    font-size: 18px;
    line-height: 18px;
  }
`;

const ReservedTargetOrdersAmount = styled.p`
  font-family: ${variables.family.goldSilver};
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  text-align: right;
  color: ${themeColors.colorTextPrimary};

  ${mediaBelow(variables.breakpoints.bpXl)} {
    font-size: 18px;
    line-height: 22px;
    margin-left: auto;
  }
`;

const ReservedTargetOrdersDescription = styled.p`
  font-family: ${variables.family.goldSilver};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  color: ${themeColors.colorTextSecondary};
  margin: 0;

  ${mediaBelow(variables.breakpoints.bpXl)} {
    font-size: 14px;
    line-height: 18px;
  }
`;

const ReservedTargetOrdersCard = ({ title, balance, description }) => (
  <ReservedTargetOrdersCardContainer>
    <ReservedTargetOrdersHeader>
      <ReservedTargetOrdersTitle>{title}</ReservedTargetOrdersTitle>
      <ReservedTargetOrdersAmount>
        {formatMoneyNumeral(balance)}
      </ReservedTargetOrdersAmount>
    </ReservedTargetOrdersHeader>
    <ReservedTargetOrdersDescription>
      {description}
    </ReservedTargetOrdersDescription>
  </ReservedTargetOrdersCardContainer>
);

ReservedTargetOrdersCard.propTypes = {
  title: PropTypes.string,
  balance: PropTypes.number,
  description: PropTypes.string,
};

export default ReservedTargetOrdersCard;
